import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    totalElements: 0,
    firms: [],
    loading: true,
    error: null,
}

const firmSlice = createSlice({
    name: 'firm',
    initialState,
    reducers: {
        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },
        loadingStopped(state) {
            state.loading = false;
        },
        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload.error;
        },
        setFirms(state, action) {
            state.firms = action.payload?.content || action.payload || [];
            state.totalElements = action.payload?.totalElements || 0;
            state.loading = false;
        },
        firmsLoaded(state, action) {
            state.firms = action.payload.firms;
            state.totalElements = action.payload.total;
        },
    }
})

export const { actions: firmActions } = firmSlice;
export const firmReducer = firmSlice.reducer;
